export default __webpack_public_path__ + "static/media/slider3.a2519f39.jpg";